/* eslint-disable-next-line */
import { $http } from "@/assets/js/appFunc";

// update permissions on edit User / Group (remove permissions)
export const actEditPermissionsUserGroup = (context, payload) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const urlType = payload.groupId ? "group-roles" : "user-roles";
    const params = {
        type: "POST",
        url: `/identity/role/application/${applicationId}/${urlType}`,
        data: payload
    };
    return $http(params, true);
};

// get permissions on edit User / Group
export const actGetPermissionsToUserGroup = (context, payload) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const url = payload.group ? "group-roles" : "user-roles";
    const params = {
        type: "GET",
        url: `/identity/role/processDefinition/${applicationId}/${url}/${payload.id}`
    };
    return $http(params, true);
};

// Get user list - possible eligible owners
export const actGetUsesListOwners = () => {
    const params = {
        type: "GET",
        url: "/identity/tenants/users/tenant-users"
    };
    return $http(params, true);
};

// Get permissions on view details role (permissions)
export const actGetPermissionsForRole = (context, code) => {
    const params = {
        type: "GET",
        url: `/identity/role/${code}/permissions`,
        noNotify: true
    };
    return $http(params, true);
};

// Get users && groups list for role (permissions)
export const actGetRoleUsersGroups = (context, data) => {
    const { roleCode, roleId } = data || {};
    const applicationId = context.rootState.main.currentApplicationId;
    const processRoleUrl = roleId ? `&roleId=${roleId}` : "";
    const params = {
        type: "GET",
        url: `/identity/role/${roleCode}/members?applicationId=${applicationId}${processRoleUrl}`,
        noNotify: true
    };
    return $http(params, true);
};

// add / remove users && groups => role (permissions)
export const actAddRemoveUsersGroupsRole = (context, payload) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const params = {
        type: payload.actionDelete ? "PUT" : "POST",
        url: `/identity/role/users-and-groups/application/${applicationId}`,
        data: payload.roleData
    };
    return $http(params, true);
};

// change application owner (permissions)
export const actPermissionsChangeOwner = (context, owner) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const params = {
        type: "POST",
        url: `/identity/tenants/users/change-owner/application/${applicationId}?newOwnerId=${owner}`,
        noNotify: true
    };
    return $http(params, true);
};

// get permissions roles
export const actGetPermissionsRoles = (context, appId) => {
    const applicationId = appId || context.rootState.main.currentApplicationId;
    const params = {
        type: "GET",
        url: `/identity/role/processDefinition/${applicationId}`,
        noNotify: true
    };
    return $http(params, true);
};

// search permissions roles
export const actGetPermissionsRolesOnSearch = (context, searchValue) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const params = {
        type: "GET",
        url: `/identity/role/searchBy?applicationId=${applicationId}&searchValue=${encodeURIComponent(searchValue)}`
    };
    return $http(params, true);
};

//  get User System Permissions
export const actGetUserSystemPermissions = (context) => {
    const params = {
        type: "GET",
        url: "/identity/permissions"
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const response = data && data.data ? data.data : {};
                context.commit("setUserSystemPermissions", response);
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

//  get Current Application User Permissions
export const actGetCurrentAppUserPermissions = (context, appId) => {
    const applicationId = context.rootState.main.currentApplicationId;
    const params = {
        type: "GET",
        url: `/identity/permissions/user-permissions?processDefinitionId=${appId || applicationId}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                const dataResponse = data && data.data ? data.data : {};
                if (context.getters.getUserSystemPermissions && context.getters.getUserSystemPermissions.hasOwnProperty("A") && !dataResponse.g) {
                    dataResponse.AS = { g: "w" };
                }
                context.commit("setCurrentAppUserPermissions", dataResponse);
                context.rootGetters["apps/currentApp"].permission = dataResponse;
                resolve(dataResponse);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const actGetAppDetails = (context, payload) => {
    const params = {
        type: "GET",
        url: `/engine/api/application/${payload}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
